import { createContext, useContext } from 'react';

function createUseContext(defaultValue) {
  const Context = createContext(defaultValue);
  function useContextConsumer(component) {
    const ctx = useContext(Context);
    const [parentName] = component.split(".");
    if (!ctx) {
      throw new Error(`${component} component was rendered outside of ${parentName} component context`);
    }
    return ctx;
  }
  return [Context.Provider, useContextConsumer];
}

export { createUseContext };
//# sourceMappingURL=create-use-context.js.map
